//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/NXObject.js";
import "../no/ContentDefinition.js";
import "../no/Assemblies.js";
let d=[[],[[["nPartitionSchemes","partitionSchemes"],"GetAllPartitionSchemes",{},0,0],[[],"GetEffectivityRangeFormula",{R_:{effectivityRangeFormula:''}},0,0],[["definitionType","journalId","journalRevisionId"],"GetContentDefinition",{R_:{contentDefinition:"ContentDefinition"}},3,0]],[["AttributeGroups","PDM.AttributeGroupCollection",0]]];
SPLM.CollaborativeDesign = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CollaborativeDesign";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;